import type { Dispatch } from "@reduxjs/toolkit";
import { startSessionExpiryLogout } from "~/features/auth/api/doLogout";
import { sessionExpired } from "~/features/auth/session/sessionExpirationSlice";

export const beginSessionExpiration = (dispatch: Dispatch) => {
  dispatch(sessionExpired());
  return startSessionExpiryLogout();
};
